import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import { GET_ADMIN_DASHBOARD_DATA_REQUEST } from "./actionTypes";
import { getAdminDashboardDataResponse } from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getAdminDashboardData() {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/Dashboard/GetAdminDashboardData",
      ""
    );
    yield put(getAdminDashboardDataResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchDashboard() {
  yield takeEvery(GET_ADMIN_DASHBOARD_DATA_REQUEST, getAdminDashboardData);
}

function* dashboardSaga() {
  yield all([fork(watchDashboard)]);
}

export default dashboardSaga;
